$mol_button_minor $mol_button_typed
